import { render, staticRenderFns } from "./DetailsTab.vue?vue&type=template&id=27f2e26f&scoped=true"
import script from "./DetailsTab.vue?vue&type=script&lang=ts"
export * from "./DetailsTab.vue?vue&type=script&lang=ts"
import style0 from "./DetailsTab.vue?vue&type=style&index=0&id=27f2e26f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f2e26f",
  null
  
)

export default component.exports